<template>
  <b-modal content-class="modal-principal"
    ref="modal"
    size="xl"
    @hide="onClose"
    no-close-on-backdrop
    hide-footer
  >
    <!-- ref="team" -->
    <template #modal-header>
      <div class="d-flex align-items-center col-12">
        <img src="https://static.zopone.com.br/img/logotipo/header/zopone.png" style="width: 45px" />
        <span class="modalTitle ml-auto">
          {{$lang.PCI.Candidate.Title}}
        </span>
        <button class="close" @click="onClose">x</button>
      </div>
    </template>
    <div class="d-flex flex-column justify-content-start h-100">
      <b-overlay :show="editing" style="width:100%;height:100%;">
        <template #overlay>
          <div class="text-center">
            <i class="far fa-edit" style="font-size:3rem;"></i>
          </div>
        </template>
        <ag-grid-vue class="ag-theme-alpine"
                  :getLocaleText="localeTextFunc"
                  :defaultColDef="defaultColumnDef"
                  :gridOptions="candidateGridOptions"
                  :columnTypes="columnTypes"
                  :columnDefs="columnDefs"
                  :rowData="list"
                  :suppressContextMenu="true"
                  :groupHeaderHeight="40"
                  :headerHeight="40"
                  :rowHeight="25"
                  :getRowId="params => params.data.id"
                  @cellDoubleClicked="onEditCandidate"
                  @rowSelected="onSelectRow"
                  rowSelection="single"
                  style="width:100%;height:100%;">
        </ag-grid-vue>
      </b-overlay>
      <b-card class="mt-3">
        <template #header>
          <div class="d-flex">
            <div class="flex-grow-1"><strong>{{$lang.PCI.Candidate.EditPanel}}</strong></div>
            <div class="card-actions">
              <b-link href="#" v-if="!editing && isRowSelected && !isCandidateSelected" v-b-tooltip.hover :title="$lang.PCI.Candidate.TooltipSelectCandidate" @click="onSelectCandidate">
                <i class="fas fa-check" style="font-size:1rem;color:var(--info);"></i>
              </b-link>
              <b-link href="#" v-if="!editing" v-b-tooltip.hover :title="$lang.PCI.Candidate.TooltipUnselectAll" @click="onUnselectAll" style="border-right: 2px solid darkgray;">
                <i class="fas fa-ban" style="font-size:1rem;color:var(--info);"></i>
              </b-link>
              <b-link href="#" v-if="!editing" v-b-tooltip.hover :title="$lang.PCI.Candidate.TooltipAddRecord" @click="onNewCandidate">
                <i class="fas fa-plus" style="font-size:1rem;color:var(--info);"></i>
              </b-link>
              <b-link href="#" v-if="!editing && isRowSelected && !isCandidateSelected" v-b-tooltip.hover :title="$lang.PCI.Candidate.TooltipEditRecord" @click="onEditCandidate">
                <i class="fas fa-edit" style="font-size:1rem;color:var(--info);"></i>
              </b-link>
              <b-link href="#" v-show="!editing && isRowSelected && !isCandidateSelected" v-b-tooltip.hover :title="$lang.PCI.Candidate.TooltipDeleteRecord" @click="onDeleteCandidate">
                <i class="fas fa-trash" style="font-size:1rem;color:var(--info);"></i>
              </b-link>
              <b-link href="#" v-if="editing" v-b-tooltip.hover :title="$lang.PCI.Candidate.TooltipSave" @click="onSave">
                <i class="fas fa-check" style="font-size:1rem;color:var(--success);"></i>
              </b-link>
              <b-link href="#" v-if="editing" v-b-tooltip.hover :title="$lang.PCI.Candidate.TooltipLeave" @click="onCancelEditCandidate">
                <i class="fas fa-times" style="font-size:1rem;color:var(--danger);"></i>
              </b-link>
            </div>
          </div>
        </template>
        <form autocomplete="off" role="presentation" @submit.stop.prevent="" class="d-flex flex-wrap">
          <b-form-group class="col-md-1 mb-1 px-0" :label="$lang.PCI.Candidate.LabelIdentification">
            <b-form-input type="text"
                          ref="txtIdentification"
                          v-model="form.identificacao.value"
                          :maxlength="form.identificacao.maxlength"
                          :disabled="!editing"
                          :required="form.identificacao.required"
                          :state="form.identificacao.state" />
          </b-form-group>
          <b-form-group class="col-md-2 mb-1 pr-0" :label="$lang.PCI.Candidate.LabelType">
            <b-form-select
                          v-model="form.tipo.value"
                          :options="form.tipo.options"
                          :maxlength="form.tipo.maxlength"
                          :disabled="!editing"
                          :required="form.tipo.required"
                          :state="form.tipo.state" />
          </b-form-group>
          <b-form-group class="col-md-3 mb-1 pr-0" :label="$lang.PCI.Candidate.LabelHolder">
            <b-form-input type="text"
                          v-model="form.detentora.value"
                          :maxlength="form.detentora.maxlength"
                          :disabled="!editing"
                          :required="form.detentora.required"
                          :state="form.detentora.state" />
          </b-form-group>
          <b-form-group class="col-md-3 mb-1" :label="$lang.PCI.Candidate.LabelHolderId">
            <b-form-input type="text"
                          v-model="form.idDetentora.value"
                          :maxlength="form.idDetentora.maxlength"
                          :disabled="!editing"
                          :required="form.idDetentora.required"
                          :state="form.idDetentora.state" />
          </b-form-group>
          <div class="col">
            <div class="row h-100">
              <div class="col-12" style="background-color:var(--vs-selected-bg);">
                <div v-if="pci" class="d-flex h-100 align-items-center">
                  <label class="m-0 pr-1" style="font-size:1rem; font-weight:bold;">{{$lang.PCI.Candidate.LabelConstruction}}</label>
                  <b-form-input v-model="refAndSite" class="text-center" :disabled="true" style="font-size:1rem;font-weight:bold;"></b-form-input>
                </div>
              </div>
            </div>
          </div>
          <b-form-group class="col-md-6 mb-1 px-0" :label="$lang.PCI.Candidate.LabelAddress">
            <b-form-input type="text"
                          v-model="form.endereco.value"
                          :maxlength="form.endereco.maxlength"
                          :disabled="!editing"
                          :required="form.endereco.required"
                          :state="form.endereco.state" />
          </b-form-group>
          <b-form-group :label="$lang.PCI.Candidate.LabelNumber" class="col-md-2 mb-1 pr-0">
            <b-form-input type="text"
                          v-model="form.numero.value"
                          :maxlength="form.numero.maxlength"
                          :disabled="!editing"
                          :required="form.numero.required"
                          :state="form.numero.state" />
          </b-form-group>
          <b-form-group class="col-md-4 mb-1 pr-0" :label="$lang.PCI.Candidate.LabelComplement">
            <b-form-input type="text"
                          v-model="form.complemento.value"
                          :maxlength="form.complemento.maxlength"
                          :disabled="!editing"
                          :required="form.complemento.required"
                          :state="form.complemento.state" />
          </b-form-group>
          <b-form-group :label="$lang.PCI.Candidate.LabelDistrict" class="col-md-5 mb-1 px-0">
            <b-form-input type="text"
                          v-model="form.bairro.value"
                          :maxlength="form.bairro.maxlength"
                          :disabled="!editing"
                          :required="form.bairro.required"
                          :state="form.bairro.state" />
          </b-form-group>
          <b-form-group class="col-md-2 mb-1 pr-0" :label="$lang.PCI.Candidate.LabelState">
            <b-form-select v-model="form.estado.value"
                          :disabled="!editing"
                          :options="form.estado.options"
                          :required="form.estado.required"
                          :state="form.estado.state"
                          @change="onChangeState">
              <template slot="first">
                <option :value="null" disabled>
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group class="col-md-5 mb-1 pr-0" :label="$lang.PCI.Candidate.LabelCity">
            <b-form-select v-model="form.cidade.value"
                           :disabled="!editing"
                           :options="form.cidade.options"
                           :required="form.cidade.required"
                           :state="form.cidade.state">
              <template slot="first">
                <option :value="null" disabled>
                  {{ $lang.Common.PlaceholderSelect }}
                </option>
              </template>
            </b-form-select>
          </b-form-group>
          <b-form-group :label="$lang.PCI.Candidate.LabelZIP" class="col-md-2 mb-0 pb-0 px-0">
            <b-form-input type="text"
                          name="txtZIP"
                          v-model="form.cep.value"
                          :disabled="!editing"
                          :required="form.cep.required"
                          :state="form.cep.state"
                          v-mask="['#####-###']" />
          </b-form-group>
          <b-form-group :label="$lang.PCI.ConstructionAddress.LabelLatitude" class="col-md-2 mb-0 pb-0 pr-0">
            <b-form-input type="number"
                          @change="validLatitude"
                          @input="generateDms(true)"
                          v-model="form.latitude.value"
                          :disabled="!editing"
                          :required="form.latitude.required"
                          :state="form.latitude.state" />
          </b-form-group>
          <b-form-group :label="$lang.PCI.ConstructionAddress.LabelLatitudeDMS" class="col-md-2 mb-0 pb-0 pr-0">
            <b-form-input
                          type="text"
                          :disabled="!editing"
                          @change="validLatitude"
                          @input="parseDms(true)"
                          :state="stateLatitude"
                          v-model="data.latitudeDms"/>
          </b-form-group>
          <b-form-group :label="$lang.PCI.ConstructionAddress.LabelLongitude" class="col-md-2 mb-0 pb-0 pr-0">
            <b-form-input type="number"
                          @change="validLongitude"
                          @input="generateDms(false)"
                          v-model="form.longitude.value"
                          :disabled="!editing"
                          :required="form.longitude.required"
                          :state="form.longitude.state" />
          </b-form-group>
          <b-form-group :label="$lang.PCI.ConstructionAddress.LabelLongitudeDMS" class="col-md-2 mb-0 pb-0 pr-0">
            <b-form-input
                          type="text"
                          :disabled="!editing"
                          @change="validLongitude"
                          @input="parseDms(false)"
                          :state="stateLongitude"
                          v-model="data.longitudeDms" />
          </b-form-group>
          <b-form-group :label="$lang.PCI.Candidate.LabelAltitude" class="col-md-2 mb-0 pb-0 pr-0">
            <b-form-input type="text"
                          v-model="form.altitude.value"
                          :disabled="!editing"
                          :required="form.altitude.required"
                          :state="form.altitude.state" />
          </b-form-group>
        </form>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import { loading, toast } from '@/shared/utils/UIHelper'
import { AgGridVue } from 'ag-grid-vue'
import ZSystemRepository from '@/shared/http/repositories/business/zsystem'
import CandidateRepository from '@/shared/http/repositories/business/constructioncandidates'
import Candidate from '@/shared/models/pci/constructioncandidate'
import Form from './candidate-form'
import gridMixin from '../../mixins/gridMixin'
import Tools from '@/components/tools/Tools'
import actionsForm from '@/shared/mixins/actionsForm'

export default {
  name: 'Candidate',
  mixins: [
    gridMixin,
    actionsForm
  ],
  components: {
    AgGridVue
  },
  computed: {
    refAndSite () {
      return this.pci ? this.pci.referencia + ' - ' + this.pci.idSite : ''
    }
  },
  data () {
    return {
      list: [],
      data: Candidate,
      pci: null,
      form: Form,
      editing: false,
      candidateGridOptions: {},
      isRowSelected: false,
      isCandidateSelected: false,
      columnDefs: [
        {
          headerName: this.$lang.PCI.Candidate.Datatable.Selected,
          field: 'selecionado',
          type: 'booleanColumn',
          width: 30
        },
        {
          headerName: this.$lang.PCI.Candidate.Datatable.Identification,
          field: 'identificacao',
          width: 50
        },
        {
          headerName: this.$lang.PCI.Candidate.Datatable.Address,
          field: 'endereco',
          width: 300
        },
        {
          headerName: this.$lang.PCI.Candidate.Datatable.Number,
          field: 'numero',
          width: 50
        },
        {
          headerName: this.$lang.PCI.Candidate.Datatable.City,
          field: 'cidade',
          width: 300
        },
        {
          headerName: this.$lang.PCI.Candidate.Datatable.State,
          field: 'estado',
          width: 50
        },
        {
          headerName: this.$lang.PCI.Candidate.Datatable.Type,
          field: 'tipo',
          width: 50
        },
        {
          headerName: this.$lang.PCI.Candidate.Datatable.Holder,
          field: 'detentora',
          width: 150
        },
        {
          headerName: this.$lang.PCI.Candidate.Datatable.HolderId,
          field: 'idDetentora',
          width: 150
        }
      ],
      latitudeDms: null,
      longitudeDms: null,
      stateLatitude: null,
      stateLongitude: null
    }
  },
  methods: {
    onLoad () {
      this.onLoadAllState()
    },
    show (pci) {
      this.pci = pci
      CandidateRepository.GetAll(pci.obraId)
        .then(response => {
          if (response.data.code > 0) {
            this.list = response.data.data
            this.$refs.modal.show()
          }
        })
        .then(() => {
          this.$nextTick(() => {
            this.candidateGridOptions.api.sizeColumnsToFit()
          })
        })
    },
    onClose () {
      this.$emit('close', this.list)
    },
    onLoadAllState () {
      loading.push()
      ZSystemRepository.GetAllUF()
        .then((response) => {
          var data = response.data.data
          const result = []
          for (var i in data) {
            result.push({ 'text': data[i].sigla, 'value': data[i].sigla })
          }
          this.form.estado.options = [...result]
        })
        .catch((err) => {
          console.log(err)
        })
        .finally(() => loading.close())
    },
    onChangeState () {
      var self = this
      setTimeout(function (e) {
        self.$nextTick(() => {
          self.onLoadAllCity(self.form.estado.value)
        })
      }, 200)
    },
    onLoadAllCity (state) {
      this.cityOptions = []
      if (state) {
        const uf = this.form.estado.options.filter(s => s.value === state)[0].value
        ZSystemRepository.GetAllCity(uf)
          .then((response) => {
            var data = response.data.data
            const result = []
            for (var i in data) {
              result.push({ 'text': data[i].nome, 'value': data[i].nome })
            }
            this.form.cidade.options = [...result]
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    onCreate () {
      loading.push()
      CandidateRepository.Create(this.data)
        .then(response => {
          if (response.data.code > 0) {
            this.list.forEach(c => {
              c.idDetentora = this.data.idDetentora
            })

            this.editing = false
            this.onClear()
            this.candidateGridOptions.api.deselectAll()
            this.candidateGridOptions.api.clearFocusedCell()
            this.candidateGridOptions.api.applyTransaction({ add: [response.data.data] })
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onUpdate () {
      loading.push()
      CandidateRepository.Update(this.data)
        .then(response => {
          if (response.data.code > 0) {
            this.list.forEach(c => {
              c.idDetentora = this.data.idDetentora
            })

            this.editing = false
            this.candidateGridOptions.api.applyTransaction({ update: [response.data.data] })
          } else {
            toast.error(this.$lang.Common.Alerts.Error)
          }
        })
        .catch(err => this.onException(err))
        .finally(() => loading.close())
    },
    onNewCandidate () {
      this.onClear()
      this.form.selecionado.value = false
      this.form.obraID.value = this.pci.obraId
      this.form.idDetentora.value = this.pci.idDetentora
      this.editing = true
      var self = this
      setTimeout(function (e) {
        self.$nextTick(() => {
          self.$refs.txtIdentification.$el.focus()
        })
      }, 200)
    },
    onUnselectAll () {
      this.createMsgBox(this.$lang.PCI.Candidate.ConfirmUnselection)
        .then(value => {
          if (value) {
            loading.push()

            this.list.forEach(c => {
              c.selecionado = false
            })

            CandidateRepository.UpdateSelection(this.list)
              .then(response => {
                if (response.data.code > 0) {
                  this.candidateGridOptions.api.applyTransaction({ update: this.list })
                } else {
                  toast.error(this.$lang.Common.Alerts.Error)
                }
              })
              .catch(err => this.onException(err))
              .finally(() => loading.close())
          }
        })
    },
    onSelectCandidate () {
      this.createMsgBox(this.$lang.PCI.Candidate.ConfirmSelection)
        .then(value => {
          if (value) {
            const row = this.candidateGridOptions.api.getSelectedRows()[0]
            loading.push()

            this.list.forEach(c => {
              c.selecionado = row.id === c.id
            })

            CandidateRepository.UpdateSelection(this.list)
              .then(response => {
                if (response.data.code > 0) {
                  this.candidateGridOptions.api.applyTransaction({ update: this.list })
                } else {
                  toast.error(this.$lang.Common.Alerts.Error)
                }
              })
              .catch(err => this.onException(err))
              .finally(() => loading.close())
          }
        })
    },
    onDeleteCandidate () {
      this.createMsgBox(this.$lang.Common.ConfirmDelete)
        .then((value) => {
          if (value) {
            const row = this.candidateGridOptions.api.getSelectedRows()[0]
            loading.push()
            CandidateRepository.Delete(row.id)
              .then(response => {
                if (response.data.code > 0) {
                  this.onClear()
                  this.candidateGridOptions.api.applyTransaction({ remove: [row] })
                } else {
                  toast.error(this.$lang.Common.Alerts.Error)
                }
              })
              .catch(err => this.onException(err))
              .finally(() => loading.close())
          }
        })
    },
    onCancelEditCandidate () {
      this.onSelectRow()
      this.editing = false
    },
    onEditCandidate () {
      if (!this.isCandidateSelected) {
        this.editing = true
        var self = this
        setTimeout(function (e) {
          self.$nextTick(() => {
            self.$refs.txtIdentification.$el.focus()
          })
        }, 200)
      }
    },
    onSelectRow () {
      this.isRowSelected = this.candidateGridOptions.api.getSelectedRows().length > 0
      if (this.isRowSelected) {
        this.isCandidateSelected = this.candidateGridOptions.api.getSelectedRows()[0].selecionado
        Tools.SetValueInForm(this.form, this.data, this.candidateGridOptions.api.getSelectedRows()[0])
        this.onLoadAllCity(this.data.estado)
        const regex = /(\d+)°(\d+)'([\d.]+)"([NSEW])/i
        if (this.form.latitude.value) {
          const match = this.form.latitude.value.trim().match(regex)
          if (match) {
            this.data.latitudeDms = this.form.latitude.value
            this.form.latitude.value = this.DMSToDecimal(this.form.latitude.value)
          } else {
            this.data.latitudeDms = this.decimalToDMS(this.form.latitude.value, true)
          }
        }
        if (this.form.longitude.value) {
          const match = this.form.longitude.value.trim().match(regex)
          if (match) {
            this.data.longitudeDms = this.form.longitude.value
            this.form.longitude.value = this.DMSToDecimal(this.form.longitude.value)
          } else {
            this.data.longitudeDms = this.decimalToDMS(this.form.longitude.value, true)
          }
        }
      } else {
        this.onClear()
      }
    },
    createMsgBox (msg) {
      const h = this.$createElement
      let messageVNode = h('div', [
        h('h4', [
          this.$lang.Common.LabelConfirmation
        ]),
        h('br')
      ])

      return this.$bvModal.msgBoxConfirm([messageVNode], {
        title: msg,
        centered: true,
        okTitle: this.$lang.Yes,
        cancelTitle: this.$lang.No,
        headerClass: 'justify-content-center'
      })
    },
    validLatitude () {
      this.form.latitude.value = this.form.latitude.value ? this.form.latitude.value.match(/^-?\d+(\.\d{0,8})?/g)[0] : ''
      const latitude = this.form.latitude.value
      const valid = !latitude || (parseFloat(latitude) >= -56.5925 && parseFloat(latitude) <= 12.4604)
      this.stateLatitude = null
      if (!valid) {
        this.stateLatitude = false
        toast.error(this.$lang.PCI.WorkMaintenance.InvalidLatitude)
      } else {
        this.stateLatitude = null
        this.data.latitudeDms = this.decimalToDMS(parseFloat(latitude), true)
      }
      return valid
    },
    validLatitudeDms () {
      try {
        this.data.latitudeDms = this.data.latitudeDms ? this.data.latitudeDms.match(/^\d+°\d+'\d+(\.\d+)?"[NSEW]$/g)[0] : this.form.latitude.value = ''
        this.form.latitude.value = this.DMSToDecimal(this.data.latitudeDms, true)
      } catch (e) {
        this.data.latitudeDms = ''
        this.stateLatitude = false
        toast.error(this.$lang.PCI.WorkMaintenance.InvalidLatitude)
      }
      return this.validLatitude()
    },
    validLongitude () {
      console.log(this.form.longitude.value)
      this.form.longitude.value = this.form.longitude.value ? this.form.longitude.value.match(/^-?\d+(\.\d{0,8})?/g)[0] : ''
      const longitude = this.form.longitude.value
      const valid = !longitude || (parseFloat(longitude) >= -81.3274 && parseFloat(longitude) <= -34.7939)
      this.stateLongitude = null
      if (!valid) {
        this.stateLongitude = false
        toast.error(this.$lang.PCI.WorkMaintenance.InvalidLongitude)
      } else {
        this.stateLongitude = null
        this.data.longitudeDms = this.decimalToDMS(parseFloat(longitude), false)
      }
      console.log(this.data.longitudeDms)
      return valid
    },
    generateDms (isLat) {
      if (isLat) {
        this.data.latitudeDms = this.decimalToDMS(parseFloat(this.form.latitude.value), true)
      } else {
        this.data.longitudeDms = this.decimalToDMS(parseFloat(this.form.longitude.value), false)
      }
    },
    parseDms (isLat) {
      if (isLat) {
        this.form.latitude.value = this.DMSToDecimal(this.data.latitudeDms, true)
      } else {
        this.form.longitude.value = this.DMSToDecimal(this.data.longitudeDms, false)
      }
    },
    decimalToDMS (decimal, isLat = true) {
      if (isNaN(decimal)) return ''

      const dir = decimal >= 0
        ? (isLat ? 'N' : 'E')
        : (isLat ? 'S' : 'W')
      const abs = Math.abs(decimal)
      const degrees = Math.floor(abs)
      const minutesFull = (abs - degrees) * 60
      const minutes = Math.floor(minutesFull)
      const seconds = ((minutesFull - minutes) * 60).toFixed(2)

      return `${degrees}°${minutes}'${seconds}"${dir}`
    },
    DMSToDecimal (dms) {
      // Remove espaços e normaliza símbolos
      dms = dms
        .trim()
        .replace(/[^\d\w.°'"-]+/g, ' ') // Substitui separadores estranhos por espaço
        .replace(/[°º]/g, '°')
        .replace(/[′’]/g, "'")
        .replace(/[″”]/g, '"')

      const regex = /(\d+(?:\.\d+)?)\s*[°º]?\s*(\d+(?:\.\d+)?)?\s*['′]?\s*(\d+(?:\.\d+)?)?\s*["″]?\s*([NSEW])/i
      const match = dms.trim().match(regex)

      if (!match) {
        toast.error(this.$lang.PCI.ConstructionAddress.InvalidDmsFormat)
        return ''
      }

      const deg = parseFloat(match[1])
      const min = parseFloat(match[2]) || 0
      const sec = parseFloat(match[3]) || 0
      const dir = match[4].toUpperCase()

      let decimal = parseInt(deg) + parseInt(min) / 60 + parseFloat(sec) / 3600

      if (dir.toUpperCase() === 'S' || dir.toUpperCase() === 'W') {
        decimal *= -1
      }

      return decimal.toFixed(8)
    }
  }
}
</script>

<style scoped>
* >>> .modal-principal .modal-body {
  height: calc(100vh - 140px);
}
* >>> .modal-header {
  border-top-left-radius: 25px;
  border-top-right-radius: 25px;
}
* >>> .modal-body {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
  overflow: hidden;
}
* >>> .modal-footer {
  border-bottom-left-radius: 25px;
  border-bottom-right-radius: 25px;
}
* >>> .modal-content {
  border-radius: 25px;
}
* >>> .col-form-label {
  padding-bottom: 1px;
}
</style>



// WEBPACK FOOTER //
// src/views/private/operational/pci/components/construction/constructionCandidate.vue